import { useLocalstorageState } from 'rooks';

const Page = ({ children }) => {
  const [isDarkMode] = useLocalstorageState(`dark-mode`, true);

  let opacity = 0.25;
  if (isDarkMode) {
    opacity = 0.1;
  }

  return (
    <div className="min-h-screen relative">
      <div
        className="absolute inset-0 bg-repeat z-0"
        style={{
          backgroundImage: "url('/topography-pattern/topography.svg')",
          backgroundAttachment: 'fixed',
          filter:
            'brightness(0) saturate(100%) invert(67%) sepia(13%) saturate(346%) hue-rotate(191deg) brightness(89%) contrast(87%)',
          opacity
        }}
      ></div>
      <div className="relative z-5 p-2">{children}</div>
    </div>
  );
};

export default Page;

// another way for reference:
// return (
//     <div className="min-h-screen relative">
//       <div
//         className="absolute inset-0 bg-repeat z-0"
//         style={{
//           backgroundImage: "url('/topography-pattern/topography.svg')",
//           backgroundAttachment: 'fixed',
//           filter: 'brightness(0) invert(1)',
//           opacity: 0.05
//         }}
//       ></div>
//       <div className="relative z-5 p-2">{children}</div>
//     </div>
//   );
